import Lottie from "lottie-react";
import { useEffect, useRef, useState } from "react";

export const LottieNetworkingOnHover = ({
    isHovered,
    animationPath,
}: {
    isHovered: boolean;
    animationPath: string;
}) => {
    const animationRef = useRef(null);

    const [animationData, setAnimationData] = useState(null);

    useEffect(() => {
        import(`../lottie-assets/${animationPath}.json`).then((animation) => {
            setAnimationData(animation.default);
        });
    }, [animationPath]);

    useEffect(() => {
        if (isHovered && animationData !== null) {
            //@ts-ignore
            animationRef.current?.play();
        } else {
            if (animationData === null) return;
            //@ts-ignore
            const totalFrames = animationRef.current?.getDuration(true);
            //@ts-ignore
            animationRef.current?.goToAndStop(totalFrames / 2, true);
        }
    }, [isHovered, animationData]);

    if (animationData === null) return null;

    return (
        <Lottie
            animationData={animationData}
            lottieRef={animationRef}
            autoplay={false}
        />
    );
};
